import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

import { STATUS_FILTERS } from '../subtasks/subtask.constants';
import Permissions from '../auth/Permissions';

const STATUS_OPTIONS = STATUS_FILTERS.map((opt) => ({
  label: opt.text,
  value: opt.value,
}));

const canModifyTask = (task) => (
  Permissions.has('TASKS_OTHERS_WRITE') || task.assigneeId === Permissions.id
);

export default function BoardCardTaskRow({
  task,
  onStatusChange,
}) {
  const { id, title, status } = task;

  const onSelectChange = (newStatus) => {
    onStatusChange(id, newStatus);
  };

  return (
    <div className="board-card-task-row">
      <div className="board-card-task-title">
        {title}
      </div>
      {canModifyTask(task) ? (
        <Select
          className="board-card-task-status"
          options={STATUS_OPTIONS}
          value={status}
          size="small"
          onChange={onSelectChange}
          onClick={(e) => e.stopPropagation()}
          dropdownMatchSelectWidth={false}
        />
      ) : (
        <span className="board-card-task-status-text">{status}</span>
      )}
    </div>
  );
}

BoardCardTaskRow.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    assigneeId: PropTypes.string,
  }).isRequired,
  onStatusChange: PropTypes.func.isRequired,
};
